/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import reducerPath from '../../../../app/reducerPath';
import mapNames from '../../constants';
// eslint-disable-next-line
import { DEFAULT_EXTENT } from '../../../../features/geo-map/GeoMap.constants';

// начальное состояние для каждой карты
const initialState = {
  [mapNames.powerBalancing]: {
    extent: DEFAULT_EXTENT,
  },
  [mapNames.logisticDelivery]: {
    extent: DEFAULT_EXTENT,
  },
  [mapNames.default]: {
    extent: DEFAULT_EXTENT,
  },
};

// хранит местоположения и масштабы карт
export const positionMapSlice = createSlice({
  name: `${reducerPath.positionMap}`,
  initialState,
  reducers: {
    setView(state, action) {
      const { name, extent, zoom } = action.payload;
      state[name] = { extent, zoom };
    },
    resetView(state, action) {
      const { name } = action.payload;
      state[name] = { extent: null, zoom: null };
    },
  },
});

export const positionMapActions = positionMapSlice.actions;
export const positionMapReducer = positionMapSlice.reducer;
